module.exports = __webpack_public_path__ + "static/media/mini-logo.68334f3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mini-logo.svg
// module id = 203
// module chunks = 0